<template>
  <div v-if="loading"></div>
  <div v-else
       class="fb-page"
       :data-href="link"
       data-tabs="timeline"
       data-height="700"
       data-width="500"
       data-small-header="true"
       data-adapt-container-width="true"
       data-hide-cover="true"
       data-show-facepile="true">
  </div>
</template>

<script>
const FACEBOOK_SCRIPT = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v3.3&appId=317341168474571&autoLogAppEvents=1'

export default {
  props: {
    link: String
  },

  data () {
    return {
      loading: true
    }
  },

  methods: {
    loadFacebookScript () {
      let script = document.getElementById('FACEBOOK_SCRIPT')
      if (!script) {
        let facebookScript = document.createElement('script')
        facebookScript.setAttribute('src', FACEBOOK_SCRIPT)
        facebookScript.setAttribute('id', 'FACEBOOK_SCRIPT')
        facebookScript.setAttribute('crossorigin', 'anonymous')
        facebookScript.async = true
        document.head.appendChild(facebookScript)
        window.fbAsyncInit = () => {
          this.loading = false
          // eslint-disable-next-line no-undef
          FB.XFBML.parse()
        }
      } else {
        this.loading = false
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          FB.XFBML.parse()
        }, 500)
      }
    }
  },

  created () {
    this.loadFacebookScript()
  }
}
</script>
